enum MailboxTypes {
    Mailbox = 'Mailbox',
    OneOff = 'OneOff',
    GroupMailbox = 'GroupMailbox',
    Group = 'Group',
    PublicDL = 'PublicDL',
    PrivateDL = 'PrivateDL',
}

export default MailboxTypes;
